import {useEffect} from 'react';

const EVENTS = [
  'mousedown',
  'mousemove',
  'keydown',
  'click',
  'touchstart',
  'scroll'
];

export default function useIdleLogout(
  onLogout,
  timeoutMs = 8*60*60*1000
) {
  useEffect(() => {
    const updateActivity = () => {
      const last = localStorage.getItem('lastActivity');

      if (last && Date.now() - Number(last) > timeoutMs) {
        checkIdle();
        return;
      }

      localStorage.setItem('lastActivity', Date.now().toString());
    };

    let loggingOut = false;

    const checkIdle = () => {
      if (loggingOut)
        return;

      const last = localStorage.getItem('lastActivity');
      if (!last)
        return;

      if (Date.now() - Number(last) > timeoutMs) {
        loggingOut = true;
        localStorage.removeItem('lastActivity');
        onLogout(true);
      }
    };

    // Event listeners to reset the timer on user interaction
    EVENTS.forEach(event =>
      window.addEventListener(event, updateActivity, {passive: true})
    );

    // Event listeners to manage logout upon page reappearance from the background
    const handleFocus = () => {
      setTimeout(checkIdle, 0);
    };

    const handleVisibility = () => {
      if (!document.hidden || document.visibilityState === 'visible') {
        setTimeout(checkIdle, 0);
      }
    };

    const handlePageShow = () => {
      setTimeout(checkIdle, 0);
    }

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('pageshow', handlePageShow);

    // Start the interval timer
    const interval = setInterval(checkIdle, 60_000);

    // Initialize the last activity timer, and run initial idle check if needed
    updateActivity();

    // Cleanup function to remove event listeners and interval
    return () => {
      clearInterval(interval);

      EVENTS.forEach(event =>
        window.removeEventListener(event, updateActivity)
      );

      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [onLogout, timeoutMs]);
}
